import { RegexValidator } from './RegexValidator'

export const URL_REGEX =
    //eslint-disable-next-line
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gi

export class URLValidator extends RegexValidator {
    constructor() {
        super(URL_REGEX, 'validations.url')
    }
}

export const URL_VALIDATOR = new URLValidator()
